import React from 'react';
import { Navigate } from 'react-router-dom';
import SuspensePage from '@/app/ui/SuspensePage';

const SellerDashboard = React.lazy(() => import('@/pages/seller/SellerDashboard'));
const SellerProfile = React.lazy(() => import('@/pages/seller/SellerProfile'));
const SellerProducts = React.lazy(() => import('@/pages/seller/SellerProducts'));
const SellerImportIA = React.lazy(() => import('@/pages/seller/SellerImportIA'));
const SellerPurchaseRequests = React.lazy(() => import('@/pages/seller/SellerPurchaseRequests'));
const SellerMessages = React.lazy(() => import('@/pages/seller/SellerMessages'));
const SellerStatistics = React.lazy(() => import('@/pages/seller/SellerStatistics'));

const sellerRoutes = [
  { index: true, element: <Navigate to="/seller/dashboard" replace /> },
  {
    path: 'dashboard',
    element: (
      <SuspensePage>
        <SellerDashboard />
      </SuspensePage>
    ),
  },
  {
    path: 'profile',
    element: (
      <SuspensePage>
        <SellerProfile />
      </SuspensePage>
    ),
  },
  {
    path: 'products',
    element: (
      <SuspensePage>
        <SellerProducts />
      </SuspensePage>
    ),
  },
  {
    path: 'products/new',
    element: (
      <SuspensePage>
        <SellerProducts />
      </SuspensePage>
    ),
  },
  {
    path: 'products/:productId',
    element: (
      <SuspensePage>
        <SellerProducts />
      </SuspensePage>
    ),
  },
  {
    path: 'products/:productId/edit',
    element: (
      <SuspensePage>
        <SellerProducts />
      </SuspensePage>
    ),
  },
  {
    path: 'import-ia',
    element: (
      <SuspensePage>
        <SellerImportIA />
      </SuspensePage>
    ),
  },
  {
    path: 'purchase-requests',
    element: (
      <SuspensePage>
        <SellerPurchaseRequests />
      </SuspensePage>
    ),
  },
  {
    path: 'messages',
    element: (
      <SuspensePage>
        <SellerMessages />
      </SuspensePage>
    ),
  },
  {
    path: 'statistics',
    element: (
      <SuspensePage>
        <SellerStatistics />
      </SuspensePage>
    ),
  },
];

export default sellerRoutes;
